import { Modal } from 'antd';

type Props = {
    open: boolean;
    url: string;
    contentType: string | null;
    onClose: () => void;
    title?: string;
};

const FilePreviewModal = ({ open, url, contentType, title = 'File Preview', onClose }: Props) => {
    const isImage = contentType?.startsWith('image/');

    const fallback = (
        <div style={{ height: '100%', display: 'grid', placeItems: 'center', padding: 24, textAlign: 'center' }}>
            <p>Your browser can't display this file inline.</p>
            <a href={url} target="_blank" rel="noopener noreferrer">
                Open in a new tab
            </a>
        </div>
    );

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            title={title}
            width="80vw"
            bodyStyle={{ height: '100vh', padding: 0 }}
            destroyOnClose
        >
            {url && (
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: 1, overflow: 'auto' }}>
                        {isImage ? (
                            <div
                                style={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: 16,
                                }}
                            >
                                <img
                                    src={url}
                                    alt="Preview"
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                            </div>
                        ) : (
                            <object
                                data={url}
                                type={contentType ?? 'application/pdf'}
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                            >
                                {fallback}
                            </object>
                        )}
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default FilePreviewModal;
